




































































































import mixins from 'vue-typed-mixins';
import tiles from './tiles';
import { SurveyGroup } from '@/utils/SurveyUtils';
import { DashboardTile, DashboardCanvas } from '@/utils/DashboardUtils';
import DashboardTileVue from './DashboardTile.vue';
import cloneDeep from 'lodash.clonedeep';
import { v4 as uuidv4 } from 'uuid';

export default mixins().extend({
  components: {
    DashboardTile: DashboardTileVue,
    ...Object.entries(tiles).reduce((result: any, [key, value]) => {
      result[key] = value.options;
      return result;
    }, {}),
  },

  props: {
    value: {
      type: Object as () => DashboardCanvas,
      required: true,
    },

    type: {
      type: String as () => string,
      required: true,
    },
  },

  computed: {
    types(): any {
      return Object.entries(tiles)
        .filter(([key, value]) => value.visible.includes(this.type))
        .map(([key, value]) => ({
          text: this.$tc(`model.dashboard.tile.type.${key}`),
          value: key,
        }));
    },

    options: {
      get(): any {
        return this.item?.value?.options;
      },
      set(options: any) {
        if (this.item && this.item.value) {
          this.item.value.options = {
            title: this.item?.value?.options?.title || this.$languageobj(),
            ...options,
          };
        }
      },
    },
  },

  data(): {
    item?: {
      column: DashboardTile[];
      value: Partial<DashboardTile>;
    };
  } {
    return {
      item: undefined,
    };
  },

  methods: {
    create(column: DashboardTile[]) {
      this.item = {
        column: column,
        value: {
          uuid: uuidv4(),
          type: undefined,
          options: undefined,
        },
      };
    },

    edit(column: DashboardTile[], item: DashboardTile) {
      this.item = {
        column: column,
        value: cloneDeep(item),
      };
    },

    remove(column: DashboardTile[], index: number) {
      column.splice(index, 1);
    },

    exit() {
      this.item = undefined;
    },

    submit() {
      if (this.item) {
        const index = this.item.column.findIndex(
          (value) => value.uuid === this.item?.value?.uuid
        );
        if (index >= 0) {
          this.item.column[index] = this.item.value as DashboardTile;
        } else {
          this.item.column.push(this.item.value as DashboardTile);
        }
        this.$emit('input', Object.assign({}, this.value)); // force update on parent
      }
      this.exit();
    },
  },
});
